var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.porcentagem !== null)?_c('div',{staticClass:"md-layout md-alignment-top-center",staticStyle:{"width":"250px"}},[_c('span',[_vm._v(_vm._s(_vm.componente.value.label))]),_c('vue-gauge',{key:_vm.idRender,attrs:{"refid":_vm.refid,"options":{
        needleColor: '#000000',
        arcColors: ['#efd613', '#3dcc5b', '#ff5454'],
        arcDelimiters: [100 / 3, (100 * 2) / 3],
        arcOverEffect: false,
        arcLabels: [
          ("" + ((_vm.intervalo / 3 + _vm.componente.value.min).toFixed(2))),
          ("" + (((_vm.intervalo * 2) / 3 + _vm.componente.value.min).toFixed(2))) ],
        arcLabelFontSize: 11,
        rangeLabel: [("" + (_vm.componente.value.min)), ("" + (_vm.componente.value.max))],
        centralLabel: ("" + (_vm.value ? _vm.value.valor.toFixed(2) : '-')),
        needleValue: _vm.porcentagem,
        needleStartValue: _vm.oldPorcentagem,
      }}}),_c('p',{staticStyle:{"margin-top":"-4vh"}},[_c('span',[_vm._v(" "+_vm._s(_vm.formatedDate)+" "),_c('md-tooltip',{attrs:{"md-direction":"bottom"}},[_vm._v(_vm._s(_vm.fullFormatedDate))])],1)])],1):_c('div',{staticStyle:{"text-align":"left"}},[_c('md-progress-spinner',{attrs:{"md-diameter":50,"md-stroke":5,"md-mode":"indeterminate"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }